var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods", style: { padding: _vm.imgActPadding } },
    [
      _c(_vm.goodsShowType, {
        tag: "component",
        attrs: { propsData: _vm.propsData },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }